import { render } from "./UploadLimitModal.vue?vue&type=template&id=17f4afe5"
import script from "./UploadLimitModal.vue?vue&type=script&lang=js"
export * from "./UploadLimitModal.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__